module.exports = __webpack_public_path__ + "static/media/pmay-g-logo.e2158281.png";